import React from 'react';

import once from 'lodash/once';

export interface TutorialProviderContext {
	state: {
		appointmentModalIsOpened: boolean;
		tutorialId: number | undefined;
		readonly: boolean;
	};
	actions: {
		setAppointmentModalIsOpened: (state: React.SetStateAction<boolean>) => void;
		setTutorialId: React.Dispatch<React.SetStateAction<number | undefined>>;
		setReadonly: React.Dispatch<React.SetStateAction<boolean>>;
		startTutorial: (id: number) => void;
	};
}

export const createTutorialProviderContext = once(() => React.createContext({} as TutorialProviderContext));

export const useTutorialProviderContext: () => TutorialProviderContext = () => React.useContext(createTutorialProviderContext());

export const AppointmentModalOpened = () => {
	const { actions: { setAppointmentModalIsOpened } } = useTutorialProviderContext();
	React.useEffect(() => {
		setAppointmentModalIsOpened(true);
		return () => {
			setAppointmentModalIsOpened(false);
		};
	}, []);
	return <></>;
};

const TutorialProvider: React.FC = ({ children }) => {
	const TutorialContext = createTutorialProviderContext();
	const [appointmentModalIsOpened, setAppointmentModalIsOpened] = React.useState(false);
	const [readonly, setReadonly] = React.useState(false);
	const [tutorialId, setTutorialId] = React.useState<number>();

	const startTutorial = (id: number) => {
		setReadonly(true);
		setTutorialId(id);
	};

	return (
		<TutorialContext.Provider value={{
			state: { appointmentModalIsOpened, tutorialId, readonly },
			actions: {
				setAppointmentModalIsOpened,
				setTutorialId,
				setReadonly,
				startTutorial,
			},
		}}
		>
			{children}
		</TutorialContext.Provider>
	);
};

export default TutorialProvider;
